import { z } from 'zod'

import { DateZod, GoogleDistanceMatrixElementZod } from '../common'
import { ConfigurationAutomatedAssignmentZod } from '../configuration/configuration-automated-assignment-zod'
import { TeamLocationZod, TeamZod } from '../teams'
import { MobileTransportRequestZod, PiloteConvertedTransportRequestZod } from '../transport-requests'

export const AssigmentTransportRequest = z
  .discriminatedUnion('type', [
    MobileTransportRequestZod.pick({
      type: true,
      origin: true,
      destination: true,
      piloteId: true,
      customerVehicle: true,
      evaluatedDistance: true,
      submitTimestamp: true,
      onboardTimestamp: true,
      regionId: true,
    }),
    PiloteConvertedTransportRequestZod.pick({
      type: true,
      origin: true,
      destination: true,
      piloteId: true,
      customerVehicle: true,
      evaluatedDistance: true,
      submitTimestamp: true,
      onboardTimestamp: true,
      regionId: true,
    }),
  ])
  .and(
    z.object({
      _id: z.string(),
      excludedTeams: z.array(z.string()).optional().default([]),
    })
  )

export const AssignmentZod = z.object({
  type: z.enum(['region', 'global']).default('region'),
  groupId: z.string().default(''),
  regionId: z.string().or(z.array(z.string())),
  eveningId: z.number().or(z.array(z.number())),
  executePlan: z.enum(['trf', 'solver', 'none']).optional().default('none'),
  dryRun: z.boolean().optional().default(false),
  timestamp: DateZod,
  deleteAt: DateZod.optional(),
  teams: z
    .array(
      TeamZod.pick({
        status: true,
        availableSince: true,
        completedTransportRequestCount: true,
        piloteId: true,
        number: true,
        vehicle: true,
        startingLocationPiloteId: true,
        availableGeolocation: true,
        availableGeolocationSince: true,
        transportRequest: true,
        regionId: true,
      }).extend({
        _id: z.string(),
        currentTransportRequest: AssigmentTransportRequest.optional(),
        currentLocation: TeamLocationZod.optional(),
      })
    )
    .optional()
    .default([]),
  transportRequests: z.array(AssigmentTransportRequest).optional().default([]),
  configuration: ConfigurationAutomatedAssignmentZod,
  realDistancesFetched: z.string().array().optional().default([]),
  realDistances: z
    .record(z.record(GoogleDistanceMatrixElementZod.or(z.literal('unavailable'))))
    .optional()
    .default({}),
})
